<template>
  <background-layout>
    <q-card tag="form" class="q-mx-auto q-mt-xl q-pa-md" style="width: 40rem; max-width: 80vw" @submit.prevent="submit">
      <q-card-section>
        <h6 class="text-center">Reset password</h6>
      </q-card-section>

      <q-card-section>
        <q-input
          v-model="password"
          type="password"
          label="Password"
          placeholder="Enter new password"
          bottom-slots
          no-error-icon
          counter
          :disable="success"
          :loading="loading"
          :error="$v.password.$dirty && $v.password.$error"
        >
          <template #error>
            <span v-if="!$v.password.required"> Password is required </span>
            <span v-else-if="!$v.password.minLength"> Password must have at least 12 characters </span>
          </template>
        </q-input>

        <q-input
          v-model="confirmPassword"
          type="password"
          label="Confirm Password"
          placeholder="Confirm new password"
          bottom-slots
          no-error-icon
          counter
          :disable="success"
          :loading="loading"
          :error="$v.confirmPassword.$dirty && $v.confirmPassword.$error"
        >
          <template #error>
            <span v-if="!$v.confirmPassword.required"> Password is required </span>
            <span v-else-if="!$v.confirmPassword.sameAs"> Passwords must match </span>
          </template>
        </q-input>
      </q-card-section>

      <q-card-actions>
        <q-btn
          type="submit"
          color="primary"
          label="Confirm new password"
          class="q-mt-md full-width"
          :loading="loading"
        />
      </q-card-actions>
    </q-card>

    <q-dialog v-model="success" persistent>
      <q-card>
        <q-card-section>
          <h6>Password reset complete!</h6>
        </q-card-section>

        <q-card-section>
          <p>You have successfully changed password, please log in again.</p>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat color="primary" label="Login" to="/login" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </background-layout>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import decode from 'jwt-decode';
import BackgroundLayout from '@/layouts/BackgroundLayout.vue';
import { getErrorMessage } from '@/utils';

export default {
  components: {
    BackgroundLayout,
  },

  data() {
    return {
      loading: false,
      success: false,
      password: '',
      confirmPassword: '',
      token: '',
    };
  },

  created() {
    const { token } = this.$route.query;

    // Redirect to home page if no token provided in query string
    if (!token) {
      this.$q.notify({ type: 'negative', message: 'No token provided!' });
      this.$router.push('/');

      return;
    }

    // Redirect to home page if query string is not a valid jwt
    try {
      decode(token);

      this.token = token;
    } catch (error) {
      this.$q.notify({ type: 'negative', message: 'Invalid token!' });
      this.$router.push('/');
    }
  },

  methods: {
    async submit() {
      this.$v.$reset();
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        this.loading = true;

        await this.$axios.post('/auth2/reset', {
          token: this.token,
          password: this.password,
        });

        this.success = true;
      } catch (error) {
        this.$q.notify({ type: 'negative', message: getErrorMessage(error) });
      } finally {
        this.loading = false;
      }
    },
  },

  validations: {
    password: {
      required,
      minLength: minLength(12),
    },
    confirmPassword: {
      required,
      sameAs: sameAs('password'),
    },
  },
};
</script>
